import { getONNXWasm } from "@/libs/onnx"
import ModelUrl from "./illumination_estimation_green_rail_4lh5ktj92q_epoch_490_with_resize_uint8.onnx?url"

export const getDependencies = async () =>
  [
    await getONNXWasm(),
    {
      url: ModelUrl,
      name: "illumination_estimation_green_rail_4lh5ktj92q_epoch_490_with_resize_uint8.onnx",
      type: "application/octet-stream",
    },
  ] as const
